import React from 'react'
import { ErrorMessage, useFormikContext,Field } from 'formik'
import { ErrorText } from './InputField';

const FormikSelectField  = (props) => {
    const { label, name, options,customFunction,hidden,required, ...rest } = props;
    const {setFieldValue,values}=useFormikContext();

    const handleChange=(e)=>{
        setFieldValue(name,e.target.value)
    }
    return (
        <div className="flex flex-col space-y-1 items-start w-full">
        <label htmlFor={label} className={`${hidden ? 'hidden ' : ''} form-label`}> <span className={`${required ? 'after:content-["*"] after:text-red-600/70' : ''}`}>{label}</span></label>
            <select id={name} name={name} {...rest} required={required}  onChange={handleChange} className="form-input" defaultValue={rest?.defaultValue}>
                <option key={0} value="">Select an Option</option>
                {
                    options&&options?.map((option,index) => (<option key={index} value={option.value}>{option.name}</option>))
                }
            </select>
            <ErrorMessage name={name} component={ErrorText} />
        </div>
    )
}

export default FormikSelectField
